export const SELECTED_LANGUAGE_LS_KEY = '@cognite/fusion/selected-language';
